export default "__VITE_ASSET__DEobP$VW__"